import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading1',
  templateUrl: './loading1.component.html',
  styleUrls: ['./loading1.component.scss']
})
export class Loading1Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
